import { useFirm } from "@app/pages/settings/useFirm";
import { CarPdfViewer } from "@app/components/PdfViewer";
import { CarAssetClassDftItem } from "../useAssetClassSummaryStat";
import { DftTotalReturnsPdfChart } from "./DftTotalReturnsPdfChart";
import { CarPdfDocument } from "@app/components/PdfDocument";
import { useUser } from "@app/pages/settings/useUser";
import { CarPdfPage, defaultClientPageSize } from "@app/components/PdfPage";
import { CarPdfBox } from "@app/components/PdfBox";
import { CarPdfTypography } from "@app/components/PdfTypography";
import { CarPdfStatBox } from "@app/components/PdfStatBox";

export const DFT_CHART_HEIGHT = 192;

interface PdfDftCompareReportProps {
  dftItem1?: CarAssetClassDftItem;
  dftItem2?: CarAssetClassDftItem;
  isLoading: boolean;
}

export const PdfDftCompareReport = ({
  dftItem1,
  dftItem2,
  isLoading,
}: PdfDftCompareReportProps) => {
  const firm = useFirm();
  const user = useUser();

  const title = `Distance From Trend - ${dftItem1?.name} vs. ${dftItem2?.name}`;
  const footer = "Asset Class Analysis";

  return (
    <CarPdfViewer isLoading={user.isLoading || firm.isLoading || isLoading}>
      <CarPdfDocument title={title} author={user.userFullName}>
        {dftItem1 && dftItem2 && (
          <CarPdfPage
            sectionTitle="Historical Analysis"
            reportTitle="Distance from Trend - Compare"
            footer={footer}
          >
            <CarPdfBox
              style={{
                flexDirection: "row",
                marginTop: 24,
              }}
            >
              <CarPdfTypography variant="v14Semibold" dense>
                {dftItem1.name}
              </CarPdfTypography>
              <CarPdfTypography
                variant="v12Regular"
                style={{ marginLeft: "auto", paddingTop: 1 }}
                dense
                italic
              >
                Start Date {dftItem1.startDate}
              </CarPdfTypography>
            </CarPdfBox>
            <CarPdfStatBox
              style={{ marginTop: 5 }}
              items={dftItem1.statItems}
              isWhiteContext
            />
            <DftTotalReturnsPdfChart
              width={defaultClientPageSize.width}
              height={DFT_CHART_HEIGHT}
              style={{ marginTop: 16 }}
              dftItem={dftItem1}
              isWhiteContext
            />
            <CarPdfBox
              style={{
                flexDirection: "row",
                marginTop: 30,
              }}
            >
              <CarPdfTypography variant="v14Semibold" dense>
                {dftItem2.name}
              </CarPdfTypography>
              <CarPdfTypography
                variant="v12Regular"
                style={{ marginLeft: "auto", paddingTop: 1 }}
                dense
                italic
              >
                Start Date {dftItem2.startDate}
              </CarPdfTypography>
            </CarPdfBox>
            <CarPdfStatBox
              style={{ marginTop: 5 }}
              items={dftItem2.statItems}
              isWhiteContext
            />
            <DftTotalReturnsPdfChart
              width={defaultClientPageSize.width}
              height={DFT_CHART_HEIGHT}
              style={{ marginTop: 16 }}
              dftItem={dftItem2}
              isWhiteContext
            />
          </CarPdfPage>
        )}
      </CarPdfDocument>
    </CarPdfViewer>
  );
};
